import React, { useState } from 'react';
import { Box, Container, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { SocialHeader } from './SocialHeader';
import { SocialSidebar } from './SocialSidebar';
import { RightSidebar } from './RightSidebar';
import { useViewPort } from '@/hooks';

const LEFT_SIDEBAR_WIDTH = 280;
const RIGHT_SIDEBAR_WIDTH = 300;
const HEADER_HEIGHT = 64;

export const DashboardLayout: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isMobile } = useViewPort();
  const theme = useTheme();

  const handleMobileMenuToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMobileMenuClose = () => {
    setMobileOpen(false);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: theme.palette.mode === 'light' ? '#f5f5f5' : 'background.default'
      }}
    >
      {/* Header */}
      <SocialHeader onMobileMenuToggle={handleMobileMenuToggle} />

      {/* Main Layout Container - Centered with lg maxWidth */}
      <Container
        maxWidth="xl"
        sx={{
          flex: 1,
          pt: `${HEADER_HEIGHT}px`,
          px: { xs: 0, sm: 2 },
          display: 'flex',
        }}
      >
        <Box sx={{ display: 'flex', flex: 1, position: 'relative', width: '100%' }}>
          {/* Left Sidebar */}
          <SocialSidebar
            mobileOpen={mobileOpen}
            onMobileClose={handleMobileMenuClose}
            width={LEFT_SIDEBAR_WIDTH}
          />

          {/* Main Content Area */}
          <Box
            component="main"
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              height: `calc(100vh - ${HEADER_HEIGHT}px)`,
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                flex: 1,
                pb: 2,
                px: { xs: 1, sm: 2 },
                overflow: 'auto',
                '&::-webkit-scrollbar': {
                  width: '6px',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'transparent',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: theme.palette.divider,
                  borderRadius: '3px',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: theme.palette.text.secondary,
                },
              }}
            >
              <Outlet />
            </Box>
          </Box>

          {/* Right Sidebar */}
          {!isMobile && (
            <RightSidebar width={RIGHT_SIDEBAR_WIDTH} />
          )}
        </Box>
      </Container>
    </Box>
  );
};